import { rpcs } from "./rpcs";
import { ccip } from "./CCIP/ccip";
import { astarDeploy } from "./deployments";

export const ccipConfig = {
  L1: { ccip: ccip.astar, rpc: rpcs.astar, deploy: astarDeploy },
  L2: { ccip: ccip.soneium, rpc: rpcs.soneium },
};
